/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import {
  Container,
  Row,
  Col,
  Spinner,
  Modal,
  Table,
} from "react-bootstrap";
import useCreateAssessment from "./useCreateAssessment";
import "react-datepicker/dist/react-datepicker.css";
import {
  faMinusCircle,
  faXmark,
  faTrashCan,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AssessmentSkillInput } from "../../../_uiComponents/Search/AssessmentSkillInput";
import MainLayout from "../../../_components/Common/MainLayout";
import TextEditor from "../../../_components/Common/Editor";
import { Select } from "antd";

export default (props) => {
  const {
    saveLoading,
    formData,
    skillsData,
    skillsData2,
    isDeleteAssessmentKitModal,
    deleteLoading,
    addSkillLoading,
    saveTypeLoading,
    deleteSkillLoading,
    isAssessmentLoading,
    deleteSkillId,
    isDeleteCustomQuestionModal,
    customQuestionsData,
    customQuestionFormData,
    customQuestionEditId,
    isAddCustomQuestion,
    skillTopics,
    customSelectedSkill,
    deleteCustomQuestionLoading,
    isSaveQuestionLoading,
    customSelectedTopic,
    onChangeCustomQuestionInput,
    onChangeSelect,
    onUpdateAssessmentKitSkill,
    handleIsDeleteAssessmentModal,
    onDeleteAssessment,
    onDeleteAssessmentSkill,
    onBlur,
    onSaveClick,
    onSkillSearch,
    onCustomQuestionSearchSelect,
    onSaveCustomQuestion,
    handleIsDeleteCustomQuestionModal,
    onDeleteCustomQuestion,
    onEditCustomQuestion,
    onCancelCustomQuestion,
    addCustomQuestion,
  } = useCreateAssessment(props);

  return (
    <MainLayout pageName="Assessment kit">
      <div className="create-interview footer-gap">
        <Container>
          <Row>
            {isAssessmentLoading ? (
              <Col lg={12} className="text-center">
                <Spinner variant="primary" />
              </Col>
            ) : (
              <>
                <Col lg={9}>
                  <div className="job-detail">
                    <Row className="bg-white border-radius-10 mx-0 mt-4 shadow-2 border px-2 py-3">
                      <Col lg={12}>
                        <div className="form-group mb-0 py-3">
                          <h3 className="pb-3 fs-20">Assessment Kit Info</h3>
                          <div className="d-flex mb-3">
                            <p className="font-weight-medium mb-0">
                              <span className="text-danger">* </span>Assessment
                              Kit Title
                              {formData?.status === "draft" ||
                              formData?.status === "archived" ? (
                                <span className="border text-capitalize border-primary text-primary px-2 rounded ml-2">
                                  {formData?.status}
                                </span>
                              ) : null}
                            </p>
                            {formData?.id && (
                              <div className="text-right ml-auto">
                                {formData?.status !== "archived" ? (
                                  <button
                                    className="border-0 bg-transparent text-danger ml-3 text-nowrap"
                                    onClick={() => onSaveClick("archived")}
                                  >
                                    <FontAwesomeIcon
                                      icon={faMinusCircle}
                                      className="mr-2"
                                    />
                                    Archive
                                  </button>
                                ) : null}
                              </div>
                            )}{" "}
                          </div>

                          <input
                            className="form-control bg-transparent"
                            type="text"
                            placeholder="Enter Assessment Kit Title"
                            name="title"
                            defaultValue={formData && formData?.title}
                            onBlur={(e) => onBlur(e)}
                          />
                        </div>

                        <div className="form-group  mb-3">
                          <p className="font-weight-medium mb-3">
                            <span className="text-danger"> </span>Addtional
                            Notes
                          </p>

                          <TextEditor
                            htmlData={formData && formData?.additional_notes}
                            getHtmlData={(data) =>
                              onBlur({
                                target: {
                                  value: data,
                                  name: "additional_notes",
                                },
                              })
                            }
                          />
                        </div>
                      </Col>
                      {formData?.id ? (
                        <Col lg={12}>
                          <div className="form-group">
                            <p className="font-weight-medium">
                              <span className="text-danger">* </span>Add Skills
                            </p>
                            <div>
                              <AssessmentSkillInput
                                data={skillsData}
                                className="form-control mw-100"
                                placeholder="Search Skill..."
                                onSearchSelect={(item) => onSkillSearch(item)}
                                clearSearch={true}
                                allowAdd={true}
                                isSkillIdNeed={true}
                              />
                              <p className="text-grey-4 pt-2">Add 3-5 skills</p>
                              <div className="col-12 text-center">
                                {addSkillLoading ? (
                                  <Spinner variant="primary" />
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </Col>
                      ) : null}
                    </Row>

                    {Array.isArray(formData?.skills) &&
                    formData?.skills.length ? (
                      <Row className="bg-white border-radius-10 mx-0 mt-4 shadow-2 border px-2 py-3">
                        <Col lg={12}>
                          <h3 className="fs-20 mb-3">Skills Info</h3>
                          <Row>
                            {Array.isArray(formData?.skills) &&
                              formData?.skills &&
                              formData?.skills.map((skill, index) => (
                                <>
                                  <Col
                                    sm={4}
                                    className="align-items-center my-3"
                                  >
                                    <span className="bg-grey inline-block py-1 rounded-sm border px-2">
                                      {skill?.skill_id &&
                                        skill?.skill_id?.skill}
                                    </span>
                                  </Col>
                                  <Col
                                    sm={8}
                                    className="d-flex align-items-center justify-content-sm-end my-2"
                                  >
                                    <div className="custom-control custom-radio mr-3 mr-xl-5">
                                      <input
                                        key={`beginner${skill?.id}`}
                                        type="radio"
                                        className="custom-control-input"
                                        id={`beginner${skill?.id}`}
                                        name={`difficulty_level${skill?.id}`}
                                        value="beginner"
                                        checked={
                                          skill?.difficulty_level &&
                                          skill?.difficulty_level === "beginner"
                                        }
                                        onChange={(e) =>
                                          onUpdateAssessmentKitSkill(e, skill)
                                        }
                                      />
                                      <label
                                        className="custom-control-label font-weight-medium"
                                        htmlFor={`beginner${skill?.id}`}
                                      >
                                        Beginner
                                      </label>
                                    </div>
                                    <div className="custom-control custom-radio mr-3 mr-xl-5">
                                      <input
                                        type="radio"
                                        key={`beginner${skill?.id}`}
                                        className="custom-control-input"
                                        id={`intermediate${skill?.id}`}
                                        name={`difficulty_level${skill?.id}`}
                                        value="intermediate"
                                        checked={
                                          skill?.difficulty_level &&
                                          skill?.difficulty_level ===
                                            "intermediate"
                                        }
                                        onChange={(e) =>
                                          onUpdateAssessmentKitSkill(e, skill)
                                        }
                                      />
                                      <label
                                        className="custom-control-label font-weight-medium"
                                        htmlFor={`intermediate${skill?.id}`}
                                      >
                                        Intermediate
                                      </label>
                                    </div>
                                    <div className="custom-control custom-radio mr-3 mr-xl-5">
                                      <input
                                        key={`beginner${skill?.id}`}
                                        type="radio"
                                        className="custom-control-input"
                                        id={`expert${skill?.id}`}
                                        name={`difficulty_level${skill?.id}`}
                                        value="expert"
                                        checked={
                                          skill?.difficulty_level &&
                                          skill?.difficulty_level === "expert"
                                        }
                                        onChange={(e) =>
                                          onUpdateAssessmentKitSkill(e, skill)
                                        }
                                      />
                                      <label
                                        className="custom-control-label font-weight-medium"
                                        htmlFor={`expert${skill?.id}`}
                                      >
                                        Expert
                                      </label>
                                    </div>
                                    <div style={{ flex: "0 0 20px" }}>
                                      {deleteSkillId === skill?.id &&
                                      deleteSkillLoading ? (
                                        <Spinner size="sm" />
                                      ) : (
                                        <button
                                          onClick={() =>
                                            onDeleteAssessmentSkill(skill?.id)
                                          }
                                          className="bg-transparent border-0"
                                        >
                                          <FontAwesomeIcon
                                            className="text-danger"
                                            icon={faXmark}
                                          />
                                        </button>
                                      )}
                                    </div>
                                  </Col>
                                </>
                              ))}
                          </Row>
                        </Col>
                      </Row>
                    ) : null}
                  </div>
                </Col>

                {formData?.id ? (
                  <Col lg={9}>
                    <div className="bg-white border-radius-10 mx-0 mt-4 shadow-2 border py-3 px-4">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <h3 className="fs-20">Custom Questions</h3>
                          <p className="fs-smallest text-grey-4">
                            You can add up to 10 custom questions to your
                            assessment.
                          </p>
                        </div>
                        <button
                          className="btn btn-primary border-radius-10"
                          onClick={() => addCustomQuestion()}
                        >
                          Add Question
                        </button>
                      </div>

                      {isAddCustomQuestion ? (
                        <Row className="border-t ">
                          <Col md={12}>
                            <div className="form-group mb-1">
                              <label
                                htmlFor=""
                                className="text-dark fs-smallest mb-1 font-weight-bold"
                              >
                                Enter Question
                              </label>
                              <textarea
                                rows="2"
                                className="form-control bg-white h-auto"
                                name="question_text"
                                placeholder="Enter your question here"
                                onBlur={(e) => {
                                  onChangeCustomQuestionInput(e);
                                }}
                              ></textarea>
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="form-group mb-1">
                              <label
                                htmlFor=""
                                className="text-dark fs-smallest mb-1 font-weight-bold"
                              >
                                Time to Answer (in Mins)
                              </label>
                              <input
                                type="number"
                                className="form-control bg-grey"
                                placeholder="Enter time (in Mins)"
                                name="time_to_answer_in_minutes"
                                onBlur={(e) => {
                                  onChangeCustomQuestionInput(e);
                                }}
                                defaultValue={
                                  customQuestionFormData?.time_to_answer_in_minutes
                                }
                              />
                            </div>
                          </Col>
                          <Col md={6}>
                            <div className="form-group mb-1">
                              <label
                                htmlFor=""
                                className="text-dark fs-smallest mb-1 font-weight-bold"
                              >
                                Select Skill
                              </label>

                              <AssessmentSkillInput
                                data={skillsData2}
                                className="form-control mw-100"
                                placeholder="Search Skill..."
                                onSearchSelect={(item) =>
                                  onCustomQuestionSearchSelect(item)
                                }
                                clearSearch={true}
                                allowAdd={true}
                                isSkillIdNeed={true}
                              />
                              {
                                <span className="d-inline-block px-2 bg-grey-3 py-1 mt-2 rounded">
                                  {customSelectedSkill}
                                </span>
                              }
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="form-group">
                              <label
                                htmlFor=""
                                className="text-dark fs-smallest mb-1 font-weight-bold"
                              >
                                Select Topic
                              </label>
                              <select
                                name="topic_id"
                                className="form-control bg-grey"
                                disabled={skillTopics.length === 0}
                                onChange={(e) => {
                                  onChangeCustomQuestionInput(e);
                                }}
                              >
                                <option value={""}>Select</option>
                                {Array.isArray(skillTopics) &&
                                  skillTopics.map((item) => (
                                    <option value={item?.id}>
                                      {item?.topic_name}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </Col>

                          <Col md={6}>
                            <div className="form-group">
                              <label
                                htmlFor=""
                                className="text-dark fs-smallest mb-1 font-weight-bold"
                              >
                                Select Difficulty
                              </label>

                              <select
                                name="difficulty_level"
                                className="form-control bg-grey"
                                onChange={(e) => {
                                  onChangeCustomQuestionInput(e);
                                }}
                              >
                                <option value={""}>Select</option>
                                <option value="easy">Easy</option>
                                <option value="medium">Medium</option>
                                <option value="hard">Hard</option>
                              </select>
                            </div>
                          </Col>
                          <Col md={12}>
                            <div className="d-flex align-items-center">
                              <button
                                className="btn btn-primary mr-3 mb-1"
                                onClick={() => onSaveCustomQuestion("create")}
                              >
                                {isSaveQuestionLoading ? (
                                  <Spinner size="sm" />
                                ) : (
                                  "Save"
                                )}
                              </button>
                              <button
                                className="btn btn-outline-light mr-3 mb-1"
                                onClick={() => onCancelCustomQuestion()}
                              >
                                Cancel
                              </button>
                            </div>
                          </Col>
                        </Row>
                      ) : null}

                      <div className="create-assessmentkit-topic-wrapper">
                        <>
                          {Array.isArray(customQuestionsData) &&
                          customQuestionsData.length ? (
                            <Table
                              borderless
                              responsive
                              className="questions-wrapper mb-0 py-2 px-0 my-3"
                            >
                              <thead className=" py-3 bg-grey-2 text-dark fs-smallest border-bottom-0">
                                <tr className="text-nowrap">
                                  <th className="font-weight-medium ">
                                    Question List
                                  </th>
                                  <th className="font-weight-medium ">
                                    Question Info
                                  </th>
                                  <th className="font-weight-medium">
                                    Actions
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="px-4 text-grey-4 text-capitalize">
                                {Array.isArray(customQuestionsData) &&
                                  customQuestionsData.map((item) => (
                                    <>
                                      <tr className="list mb-2 py-2 border-bottom">
                                        <td className="fs-14 text-left text-dark-2 font-weight-medium">
                                          {item?.question_bank_question_id &&
                                            item?.question_bank_question_id
                                              ?.question_text}
                                        </td>
                                        <td className="text-left">
                                          <p className="mb-0 d-inline-block text-nowrap fs-smallest ml-1 px-2 bg-grey border rounded-lg mb-1">
                                            {item?.question_bank_question_id &&
                                              item?.question_bank_question_id
                                                ?.time_to_answer_in_minutes}
                                            mins
                                          </p>
                                          <span className="mb-0 d-inline-block text-nowrap fs-smallest border ml-1  px-2 bg-grey rounded-lg text-capitalize mb-1">
                                            {item?.question_bank_question_id &&
                                              item?.question_bank_question_id
                                                ?.skill_id &&
                                              item?.question_bank_question_id
                                                ?.skill_id?.skill}
                                          </span>
                                          <span className="mb-0 d-inline-block ml-1 fs-smallest  px-2 bg-grey border rounded-lg text-capitalize mb-1">
                                            {item?.question_bank_question_id &&
                                              item?.question_bank_question_id
                                                ?.difficulty_level}
                                          </span>
                                        </td>
                                        <td className="text-left d-flex">
                                          <button
                                            className="cursor-pointer font-weight-medium border-0 bg-transparent"
                                            onClick={() =>
                                              handleIsDeleteCustomQuestionModal(
                                                item?.id
                                              )
                                            }
                                          >
                                            <FontAwesomeIcon
                                              icon={faTrashCan}
                                              className="ml-2 text-grey-4"
                                            />
                                          </button>

                                          {customQuestionEditId ===
                                          item?.question_id?.id ? (
                                            <button
                                              className="cursor-pointer font-weight-medium text-danger border-0 bg-transparent"
                                              onClick={() =>
                                                onCancelCustomQuestion()
                                              }
                                            >
                                              <FontAwesomeIcon
                                                icon={faXmark}
                                                className="ml-3"
                                              />
                                            </button>
                                          ) : (
                                            <button
                                              className="cursor-pointer font-weight-medium text-success border-0 bg-transparent"
                                              onClick={() =>
                                                onEditCustomQuestion(
                                                  item,
                                                  item?.id
                                                )
                                              }
                                            >
                                              <FontAwesomeIcon
                                                icon={faPencil}
                                                className="ml-3"
                                              />
                                            </button>
                                          )}
                                        </td>
                                      </tr>
                                      {customQuestionEditId === item?.id ? (
                                        <tr>
                                          <td colSpan={3}>
                                            <Row>
                                              <Col md={12}>
                                                <div className="form-group mb-1">
                                                  <label
                                                    htmlFor=""
                                                    className="text-dark fs-smallest mb-1 font-weight-bold"
                                                  >
                                                    Enter Question
                                                  </label>
                                                  <textarea
                                                    rows="4"
                                                    className="form-control bg-white h-100"
                                                    name="question_text"
                                                    placeholder="Enter your question here"
                                                    onBlur={(e) => {
                                                      onChangeCustomQuestionInput(
                                                        e
                                                      );
                                                    }}
                                                    defaultValue={
                                                      customQuestionFormData?.question_text
                                                    }
                                                  ></textarea>
                                                </div>
                                              </Col>
                                              <Col md={6}>
                                                <div className="form-group mb-1">
                                                  <label
                                                    htmlFor=""
                                                    className="text-dark fs-smallest mb-1 font-weight-bold"
                                                  >
                                                    Time to Answer (in Mins)
                                                  </label>
                                                  <input
                                                    type="number"
                                                    className="form-control bg-grey"
                                                    placeholder="Enter time (in Mins)"
                                                    name="time_to_answer_in_minutes"
                                                    defaultValue={
                                                      customQuestionFormData?.time_to_answer_in_minutes
                                                    }
                                                    onBlur={(e) => {
                                                      onChangeCustomQuestionInput(
                                                        e
                                                      );
                                                    }}
                                                  />
                                                </div>
                                              </Col>
                                              <Col md={6}>
                                                <div className="form-group">
                                                  <label
                                                    htmlFor=""
                                                    className="text-dark fs-smallest mb-1 font-semibold"
                                                  >
                                                    Select Difficulty Level
                                                  </label>

                                                  {customQuestionFormData &&
                                                  customQuestionFormData?.difficulty_level ? (
                                                    <Select
                                                      className="col-lg-12 px-0 position-relative h-auto"
                                                      defaultValue={
                                                        customQuestionFormData &&
                                                        customQuestionFormData?.difficulty_level
                                                      }
                                                      placeholder="Select"
                                                      onChange={(e) => {
                                                        onChangeSelect(
                                                          e,
                                                          "difficulty_level"
                                                        );
                                                      }}
                                                      getPopupContainer={(
                                                        trigger
                                                      ) => trigger.parentNode}
                                                      options={[
                                                        {
                                                          value: "easy",
                                                          label: "Easy",
                                                        },
                                                        {
                                                          value: "medium",
                                                          label: "Medium",
                                                        },
                                                        {
                                                          value: "hard",
                                                          label: "Hard",
                                                        },
                                                      ]}
                                                    />
                                                  ) : null}
                                                </div>
                                              </Col>
                                              <Col md={6}>
                                                <div className="form-group mb-1">
                                                  <label
                                                    htmlFor=""
                                                    className="text-dark fs-smallest mb-1 font-weight-bold"
                                                  >
                                                    Select Skill
                                                  </label>

                                                  <AssessmentSkillInput
                                                    data={skillsData2}
                                                    className="form-control mw-100"
                                                    placeholder="Search Skill..."
                                                    onSearchSelect={(item) =>
                                                      onCustomQuestionSearchSelect(
                                                        item
                                                      )
                                                    }
                                                    clearSearch={true}
                                                    allowAdd={true}
                                                    isSkillIdNeed={true}
                                                  />
                                                  {
                                                    <span className="d-inline-block px-2 bg-grey-3 py-1 mt-2 rounded">
                                                      {customSelectedSkill}
                                                    </span>
                                                  }
                                                </div>
                                              </Col>
                                              <Col md={6}>
                                                <div className="form-group">
                                                  <label
                                                    htmlFor=""
                                                    className="text-dark fs-smallest mb-1 font-weight-bold"
                                                  >
                                                    Select topic
                                                  </label>

                                                  {customQuestionFormData?.topic_id ? (
                                                    <Select
                                                      className="col-lg-12 px-0 position-relative h-auto"
                                                      defaultValue={
                                                        skillTopics.find(
                                                          (item) =>
                                                            item.id ===
                                                            customQuestionFormData?.topic_id
                                                        )
                                                          ? skillTopics.find(
                                                              (item) =>
                                                                item.id ===
                                                                customQuestionFormData?.topic_id
                                                            ).topic_name
                                                          : null
                                                      }
                                                      placeholder="Select"
                                                      onChange={(e, label) => {
                                                        onChangeSelect(
                                                          e,
                                                          "topic_id",
                                                          label?.label
                                                        );
                                                      }}
                                                      getPopupContainer={(
                                                        trigger
                                                      ) => trigger.parentNode}
                                                      options={
                                                        Array.isArray(
                                                          skillTopics
                                                        ) &&
                                                        skillTopics.map(
                                                          (item) => ({
                                                            value: item?.id,
                                                            label:
                                                              item?.topic_name,
                                                          })
                                                        )
                                                      }
                                                    />
                                                  ) : null}
                                                </div>
                                              </Col>

                                              <Col md={12}>
                                                <div className="d-flex align-items-center">
                                                  <button
                                                    className="btn btn-primary mr-3 mb-1"
                                                    onClick={() =>
                                                      onSaveCustomQuestion(
                                                        "update",
                                                        customQuestionEditId
                                                      )
                                                    }
                                                  >
                                                    {isSaveQuestionLoading ? (
                                                      <Spinner size="sm" />
                                                    ) : (
                                                      "Update"
                                                    )}
                                                  </button>
                                                  <button
                                                    className="btn btn-outline-light mr-3 mb-1"
                                                    onClick={() =>
                                                      onCancelCustomQuestion()
                                                    }
                                                  >
                                                    Cancel
                                                  </button>
                                                </div>
                                              </Col>
                                            </Row>
                                          </td>{" "}
                                        </tr>
                                      ) : null}
                                    </>
                                  ))}
                              </tbody>
                            </Table>
                          ) : null}
                        </>
                      </div>
                    </div>
                  </Col>
                ) : null}
                <Col lg={9}>
                  <div className="action py-2 mt-3 d-flex">
                    {formData?.id ? (
                      <>
                        {formData?.status === "draft" ? (
                          <button
                            className="btn btn-white-new mr-3"
                            onClick={() => onSaveClick("draft")}
                            disabled={
                              saveLoading && saveTypeLoading === "draft"
                            }
                          >
                            {saveLoading && saveTypeLoading === "draft" ? (
                              <Spinner
                                animation="border"
                                size="sm"
                                variant="secondary"
                              />
                            ) : (
                              "Save Draft"
                            )}
                          </button>
                        ) : null}

                        {Array.isArray(formData?.skills) &&
                        formData?.skills.length ? (
                          <button
                            className="btn btn-primary"
                            onClick={() => onSaveClick("publish")}
                            disabled={
                              saveLoading && saveTypeLoading === "publish"
                            }
                          >
                            {saveLoading && saveTypeLoading === "publish" ? (
                              <Spinner
                                animation="border"
                                size="sm"
                                variant="white"
                              />
                            ) : (
                              "Publish"
                            )}
                          </button>
                        ) : null}
                      </>
                    ) : (
                      <button
                        className="btn btn-primary"
                        onClick={() => onSaveClick("draft")}
                        disabled={saveLoading && saveTypeLoading === "create"}
                      >
                        {saveLoading && saveTypeLoading === "create" ? (
                          <Spinner
                            animation="border"
                            size="sm"
                            variant="white"
                          />
                        ) : (
                          "Create"
                        )}
                      </button>
                    )}
                  </div>
                </Col>
              </>
            )}
          </Row>
        </Container>

        <Modal
          show={isDeleteAssessmentKitModal}
          centered
          size="md"
          onHide={() => handleIsDeleteAssessmentModal()}
          className="common-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h3>Delete Assessment Kit</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3 bg-white d-flex align-items-center justify-content-center flex-column">
            <h4>Are you sure you want to delete this Assessment Kit?</h4>

            <div className="action mt-4">
              <button
                className="btn btn-primary px-5"
                onClick={() => onDeleteAssessment(formData?.id)}
              >
                {deleteLoading ? (
                  <Spinner animation="border" variant="white" />
                ) : (
                  "Yes"
                )}
              </button>
              {formData?.id ? (
                <button
                  className="btn btn-dark ml-4 px-5"
                  onClick={() => handleIsDeleteAssessmentModal()}
                >
                  Cancel
                </button>
              ) : null}
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={isDeleteCustomQuestionModal}
          centered
          size="md"
          onHide={() => handleIsDeleteCustomQuestionModal()}
          className="common-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h3>Delete Assessment Kit</h3>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="p-3 bg-white d-flex align-items-center justify-content-center flex-column">
            <h4>Are you sure you want to this Question?</h4>

            <div className="action mt-4">
              <button
                className="btn btn-primary px-5"
                onClick={() => onDeleteCustomQuestion()}
              >
                {deleteCustomQuestionLoading ? (
                  <Spinner animation="border" variant="white" />
                ) : (
                  "Yes"
                )}
              </button>
              {formData?.id ? (
                <button
                  className="btn btn-dark ml-4 px-5"
                  onClick={() => handleIsDeleteCustomQuestionModal()}
                >
                  Cancel
                </button>
              ) : null}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </MainLayout>
  );
};
